'use client';

import { useEffect } from 'react';
import { useReportWebVitals } from 'next/web-vitals';
import { useThirdPartyScriptsConfig } from '@/features/third-party-scripts/use-third-party-scripts-config';
import { initRumLifecycle, reportMetric, setRumSampleRate } from './collector';
export function Rum() {
  const {
    data
  } = useThirdPartyScriptsConfig();
  const rum = data?.rum;
  useEffect(() => {
    initRumLifecycle();
  }, []);
  useReportWebVitals(reportMetric);
  useEffect(() => {
    if (!rum) return;
    setRumSampleRate(rum.enabled ? rum.config.sampleRate : 0);
  }, [rum]);
  return null;
}